import { PureComponent } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { toHexadecimal } from '../Utilitarios';

const DEFAULT_ICON_SIZE = 30;
const DEFAULT_ICON_COLOR = 'black';

export default function createIcon(glyphMap, fontFamily, fontFile) {
  const IconNamePropType = PropTypes.oneOf(Object.keys(glyphMap));

  class Icon extends PureComponent {
    static propTypes = {
      allowFontScaling: PropTypes.bool,
      name: IconNamePropType,
      size: PropTypes.number,
      color: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    };

    static defaultProps = {
      size: DEFAULT_ICON_SIZE,
      color: DEFAULT_ICON_COLOR,
      allowFontScaling: false,
    };

    render() {
      const { name, size, color, ...props } = this.props;

      function resolveGlyph(name) {
        const glyph = glyphMap[name] || '?';
        if (typeof glyph === 'number') {
          return String.fromCodePoint(glyph);
        }
        return glyph;
      }

      const IconStyle = styled.span`
        @font-face {
          font-family: ${fontFamily};
          src: url('${fontFile}') format('truetype');
          font-weight: normal;
          font-style: normal;
        }
        font-family: ${fontFamily};
        border-color: ${({ color }) => color};
        color: ${({ color }) => color};
        display: flex;
        justify-content: center;
        align-items: center;
        &&:before {
          content: '${({ name }) => name}';
          font-size: ${({ size }) => size};
        }
      `;

      return (
        <IconStyle
          name={`\\${toHexadecimal(resolveGlyph(name))}`}
          color={color}
          size={`${size}px`}
        />
      );
    }
  }

  return Icon;
}
